import {
  DashboardOutlined,
  FileDoneOutlined,
  TeamOutlined,
  FolderOpenOutlined,
  LikeOutlined,
  FileSearchOutlined,
  SettingOutlined,
  DatabaseOutlined,
  ShopOutlined,
  ShopFilled,
  ClockCircleOutlined,
  ContactsOutlined,
  MailOutlined,
  SolutionOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  AppstoreOutlined,
  GiftOutlined,
  CrownOutlined,
  PictureOutlined,
  PlaySquareOutlined,
  ReadOutlined,
  IdcardOutlined,
  GlobalOutlined,
  ApiOutlined,
  PercentageOutlined,
} from "@ant-design/icons";

// ==================== CONST DATA START ==================== //

import LS_SERVICE from "../utils/localStorage";
import { getAPI } from "../utils/common";
import { SETTING } from "./api";

// Project Info
export const DEMO_MODE = false;
export const PROJECT_NAME = "HotelNXT Booking Software";
export const CREATOR_NAME = "AW Digital Support";
export const CREATOR_LINK = "https://www.awdigitalsupport.com";
export const CURRENCY = "₹";
export const HOTEL_ID_SERIES = "HNXT-";
export const BILL_DUE_WARNING = 7;
export const BILL_BLOCK_SYSTEM = 9;
// Theme
export const THEME = "d9534f";
export const SECONDARY_THEME = "3f37c9";
export const INV_THEME = "e2ecee";
export const RADIUS = "30px";
// Pusher use for notification
// export const PUSHER_APP_KEY = "44afc837bb5faa25f733"; // Hotelshivmanglam
export const PUSHER_APP_KEY = "e7e2a4eb930172ae9658"; // Testing
// export const PUSHER_APP_KEY = "76115cf98aac8039b6d7";
export const PUSHER_APP_CLUSTER = "ap2";
// ==================== CONST DATA END ==================== //

export const colProps = { xs: 24, sm: 12, md: 8, lg: 6 };

/* ================= VALIDATION RULES START ================= */

export const phoneRegex = /^[6-9]\d{9}$/;
export const whatsappRegex = /^\+?[0-9]{10,14}$/;
export const urlRegex =
  /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-./?%&=]*)?$/i;

/* ================= VALIDATION RULES END ================= */

export const LEAD_STATUS = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "interested", label: "Interested" },
  { value: "meeting_scheduled", label: "Meeting Scheduled" },
  { value: "documents_pending", label: "Documents Pending" },
  { value: "not_interested", label: "Not Interested" },
  { value: "converted", label: "Converted" },
];

export const HOTEL_TYPE = [
  { value: "hotel", label: "Hotel" },
  { value: "guesthouse", label: "Guesthouse" },
  { value: "homestay", label: "Homestay" },
  { value: "resort", label: "Resort" },
  { value: "hostel", label: "Hostel" },
  { value: "motel", label: "Motel" },
  { value: "apartment", label: "Serviced Apartment" },
  { value: "villa", label: "Villa" },
  { value: "cottage", label: "Cottage" },
  { value: "bungalow", label: "Bungalow" },
  { value: "lodge", label: "Lodge" },
  { value: "inn", label: "Inn" },
  { value: "boutique_hotel", label: "Boutique Hotel" },
  { value: "luxury_hotel", label: "Luxury Hotel" },
  { value: "budget_hotel", label: "Budget Hotel" },
  { value: "business_hotel", label: "Business Hotel" },
  { value: "heritage_hotel", label: "Heritage Hotel" },
  { value: "farm_stay", label: "Farm Stay" },
  { value: "eco_lodge", label: "Eco Lodge" },
  { value: "camping", label: "Camping / Campsite" },
  { value: "glamping", label: "Glamping" },
  { value: "bed_and_breakfast", label: "Bed and Breakfast" },
  { value: "dormitory", label: "Dormitory" },
  { value: "holiday_home", label: "Holiday Home" },
  { value: "vacation_rental", label: "Vacation Rental" },
  { value: "treehouse", label: "Treehouse" },
  { value: "houseboat", label: "Houseboat" },
  { value: "caravan", label: "Caravan / RV Stay" },
  { value: "ryokan", label: "Ryokan" },
  { value: "other", label: "Other" },
];

export const BILLING_CYCLE = [
  { value: 1, label: "Monthly" },
  { value: 3, label: "Quarterly (3 Months)" },
  { value: 6, label: "Half-Yearly (6 Months)" },
  { value: 12, label: "Yearly" },
];

export const YES_NO_OPTION = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

export const ACTIVE_INACTIVE_OPTION = [
  { value: "pending", label: "Pending" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

export const APPROVED_REJECT_OPTION = [
  { value: "approved", label: "Approved" },
  { value: "pending", label: "Pending" },
  { value: "reject", label: "Rejected" },
];

export const ROOM_CAPACITY_TYPES = [
  { value: "S", label: "Single", capacity: 1 },
  { value: "D", label: "Double", capacity: 2 },
  { value: "T", label: "Triple", capacity: 3 },
  { value: "Q", label: "Quad", capacity: 4 },
  { value: "P", label: "Quint", capacity: 5 },
  { value: "H", label: "Hextuple", capacity: 6 },
  { value: "HP", label: "Heptuple", capacity: 7 },
  { value: "O", label: "Octuple", capacity: 8 },
  { value: "N", label: "Nonuple", capacity: 9 },
  { value: "DE", label: "Decuple", capacity: 10 },
  { value: "EL", label: "Eleven", capacity: 11 },
  { value: "TW", label: "Twelve", capacity: 12 },
  { value: "TH", label: "Thirteen", capacity: 13 },
  { value: "FO", label: "Fourteen", capacity: 14 },
  { value: "FI", label: "Fifteen", capacity: 15 },
  { value: "SI", label: "Sixteen", capacity: 16 },
  { value: "SE", label: "Seventeen", capacity: 17 },
  { value: "EI", label: "Eighteen", capacity: 18 },
  { value: "NI", label: "Nineteen", capacity: 19 },
  { value: "TWE", label: "Twenty", capacity: 20 },
];

export const OTA_SERVICE_TYPE = [
  {
    value: "ep",
    label: "EP (Room Only)",
    description: "EP: Room only, no meals included.",
  },
  {
    value: "cp",
    label: "CP (Room with Breakfast)",
    description: "CP: Room with breakfast included.",
  },
  {
    value: "map",
    label: "MAP (Room with Breakfast & Lunch or Dinner)",
    description:
      "MAP: Room with breakfast and either lunch or dinner included.",
  },
  {
    value: "ap",
    label: "AP (Room with Breakfast, Lunch & Dinner)",
    description: "AP: Room with breakfast, lunch, and dinner included.",
  },
];

export const DYNAMIC_PAGE_TYPE = [
  {
    value: "term",
    label: "Terms and Conditions",
  },
  {
    value: "privacy",
    label: "Privacy Policy",
  },
  {
    value: "product-1",
    label: "Property Management System (PMS)",
  },
  {
    value: "product-2",
    label: "Hotel Booking Engine",
  },
  {
    value: "product-3",
    label: "Premium Hotel Website",
  },
];

export const USER_TYPE = [
  {
    value: "superAdmin",
    label: "Super Admin",
  },
  {
    value: "admin",
    label: "Admin",
  },
  {
    value: "webAdmin",
    label: "Web Admin",
  },
  {
    value: "bde",
    label: "Business Development Executive",
  },
  {
    value: "vendor",
    label: "Hotel Owner (Vendor)",
  },
];

export const CAREER_TYPE = [
  { label: "Full Time", value: "Full Time" },
  { label: "Part Time", value: "Part Time" },
  { label: "Internship", value: "Internship" },
  { label: "Remote", value: "Remote" },
  { label: "Contract", value: "Contract" },
  { label: "Freelance", value: "Freelance" },
];

export const PAGES_TYPE = [
  {
    value: "home",
    label: "Home",
  },
  {
    value: "about",
    label: "About",
  },
  {
    value: "pricing",
    label: "Pricing",
  },
  {
    value: "careers",
    label: "Careers",
  },
  {
    value: "product-1",
    label: "Property Management System (PMS)",
  },
  {
    value: "product-2",
    label: "Hotel Booking Engine",
  },
  {
    value: "hotels",
    label: "Hotels",
  },
  {
    value: "news",
    label: "News",
  },
  {
    value: "news-detail",
    label: "News Detail",
  },
  {
    value: "contact",
    label: "Contact",
  },
  {
    value: "product-3",
    label: "Premium Hotel Website",
  },
];

export const VENDOR_DOCUMENTS = [
  {
    key: 1,
    id: 1,
    label: "PAN Card",
    imageKey: "pan_image",
    statusKey: "doc_pan_card_is_approved",
    remarkKey: "doc_pan_card_remark",
  },
  {
    key: 2,
    id: 2,
    label: "Aadhar Front",
    imageKey: "aadhar_front_image",
    statusKey: "doc_aadhar_is_approved",
    remarkKey: "doc_aadhar_remark",
  },
  {
    key: 3,
    id: 3,
    label: "Aadhar Back",
    imageKey: "aadhar_back_image",
    statusKey: "doc_aadhar_is_approved",
    remarkKey: "doc_aadhar_remark",
  },
  {
    key: 4,
    id: 4,
    label: "GST",
    imageKey: "gst_image",
    statusKey: "doc_gst_certificate_is_approved",
    remarkKey: "doc_gst_certificate_remark",
  },
  {
    key: 5,
    id: 5,
    label: "MSME",
    imageKey: "msme_image",
    statusKey: "doc_msme_certificate_is_approved",
    remarkKey: "doc_msme_certificate_remark",
  },
  {
    key: 6,
    id: 6,
    label: "Trade License",
    imageKey: "trade_image",
    statusKey: "doc_trade_license_is_approved",
    remarkKey: "doc_trade_license_remark",
  },
  {
    key: 7,
    id: 7,
    label: "Passbook",
    imageKey: "passbook_image",
    statusKey: "doc_bank_passbook_is_approved",
    remarkKey: "doc_bank_passbook_remark",
  },
  {
    key: 8,
    id: 8,
    label: "Hotel Profile",
    imageKey: "hotel_profile_image",
    statusKey: "doc_hotel_profile_is_approved",
    remarkKey: "doc_hotel_profile_remark",
  },
];

// -------------------- Role-wise MENU LIST --------------------
export const MENU_SUPER_ADMIN = [
  {
    category: "Dashboard",
    items: [
      {
        key: "dashboard",
        icon: <DashboardOutlined />,
        label: "Dashboard",
        to: "/",
      },
    ],
  },
  {
    category: "Vendors",
    items: [
      {
        key: "vendor",
        icon: <ShopOutlined />,
        label: "All Vendor",
        to: "/vendor",
      },
      ...ACTIVE_INACTIVE_OPTION.map((item) => ({
        key: `vendor_${item.value}`,
        icon: <ShopFilled />,
        label: `${item.label} Vendor`,
        to: `/vendor?type=${item.value}`,
      })),
    ],
  },
  {
    category: "Billing & Finance",
    items: [
      {
        key: "upcoming-billing",
        icon: <ClockCircleOutlined />,
        label: "Upcoming Billing",
        to: "/vendor/upcoming-billing",
      },
      {
        key: "vendor-bills",
        icon: <FileDoneOutlined />,
        label: "Generated Bill",
        to: "/vendor/bills",
      },
      {
        key: "pending-discount",
        icon: <PercentageOutlined />,
        label: "Pending Discount Bill",
        to: "/vendor/bills/pending-discount",
      },
    ],
  },
  {
    category: "Leads & Enquiries",
    items: [
      {
        key: "lead",
        icon: <SolutionOutlined />,
        label: "All Lead",
        to: "/lead",
      },
      ...LEAD_STATUS.map((item) => ({
        key: `lead_${item.value}`,
        icon: <SolutionOutlined />,
        label: `${item.label} Lead`,
        to: `/lead?type=${item.value}`,
      })),
      {
        key: "contacts",
        icon: <ContactsOutlined />,
        label: "Enquiries / Contacts",
        to: "/contacts",
      },
      {
        key: "newsletter",
        icon: <MailOutlined />,
        label: "Newsletter",
        to: "/newsletter",
      },
      {
        key: "career-query",
        icon: <IdcardOutlined />,
        label: "Career Query",
        to: "/career-query",
      },
    ],
  },
  {
    category: "Masters",
    items: [
      {
        key: "master-facility",
        icon: <AppstoreOutlined />,
        label: "Facility",
        to: "/master/facility",
      },
      {
        key: "discount-coupon",
        icon: <GiftOutlined />,
        label: "Discount Coupon",
        to: "/master/discount-coupon",
      },
      {
        key: "subscription-plan",
        icon: <CrownOutlined />,
        label: "Subscription Plan",
        to: "/master/subscription-plan",
      },
    ],
  },
  {
    category: "Website - Media & Pages",
    items: [
      {
        key: "file-manager",
        icon: <FolderOpenOutlined />,
        label: "File Manager",
        to: "/file-manager",
      },
      {
        key: "gallery",
        icon: <PictureOutlined />,
        label: "Gallery",
        to: "/gallery",
      },
      {
        key: "slider",
        icon: <PlaySquareOutlined />,
        label: "Homepage Slider",
        to: "/slider",
      },
      {
        key: "team",
        icon: <TeamOutlined />,
        label: "Team Members",
        to: "/team",
      },
      {
        key: "testimonial",
        icon: <LikeOutlined />,
        label: "Testimonials",
        to: "/testimonial",
      },
      {
        key: "blog",
        icon: <ReadOutlined />,
        label: "Blog / News",
        to: "/blog",
      },
      {
        key: "career",
        icon: <SolutionOutlined />,
        label: "Career",
        to: "/career",
      },
    ],
  },
  {
    category: "Logs",
    items: [
      {
        key: "webhooks_logs",
        icon: <ApiOutlined />,
        label: "WebHooks Logs",
        to: "/log/webhooks",
      },
      {
        key: "bills_logs",
        icon: <FileDoneOutlined />,
        label: "Bills Logs",
        to: "/log/bills",
      },
      {
        key: "discount_logs",
        icon: <PercentageOutlined />,
        label: "Discount Logs",
        to: "/log/discount",
      },
    ],
  },
  {
    category: "Administration",
    items: [
      {
        key: "staff",
        icon: <UsergroupAddOutlined />,
        label: "Staff Users",
        to: "/user",
      },
      {
        key: "pages-seo",
        icon: <GlobalOutlined />,
        label: "SEO Settings",
        to: "/pages-seo",
      },
      {
        key: "dynamic-content",
        icon: <FileSearchOutlined />,
        label: "Dynamic Pages",
        to: "/pages",
      },
      {
        key: "setting",
        icon: <SettingOutlined />,
        label: "Global Settings",
        to: "/setting",
      },
      {
        key: "profile",
        icon: <UserOutlined />,
        label: "My Profile",
        to: "/profile/update",
      },
      {
        key: "db_manager",
        icon: <DatabaseOutlined />,
        label: "DB Manager",
        to: "/db-manage",
      },
    ],
  },
];

// -------------------- Vendor MENU --------------------
export const MENU_VENDOR = [
  {
    category: "Dashboard",
    items: [
      {
        key: "dashboard",
        icon: <DashboardOutlined />,
        label: "Dashboard",
        to: "/",
      },
      {
        key: "vendor-bills",
        icon: <FileDoneOutlined />,
        label: "My Bill",
        to: `/my/bills/${LS_SERVICE.get("vendor_id")}`,
      },
      {
        key: "profile",
        icon: <UserOutlined />,
        label: "My Profile",
        to: "/profile/update",
      },
    ],
  },
];

// -------------------- BDE MENU --------------------
export const MENU_BDE = [
  {
    category: "Dashboard",
    items: [
      {
        key: "dashboard",
        icon: <DashboardOutlined />,
        label: "Dashboard",
        to: "/",
      },
    ],
  },
  {
    category: "Leads",
    items: [
      {
        key: "lead",
        icon: <SolutionOutlined />,
        label: "All Lead",
        to: "/lead",
      },
      ...LEAD_STATUS.map((item) => ({
        key: `lead_${item.value}`,
        icon: <SolutionOutlined />,
        label: `${item.label} Lead`,
        to: `/lead?type=${item.value}`,
      })),
    ],
  },
  {
    category: "Account",
    items: [
      {
        key: "profile",
        icon: <UserOutlined />,
        label: "My Profile",
        to: "/profile/update",
      },
    ],
  },
];

// -------------------- Helper: get menu by role --------------------
export const getMenuByRole = (role) => {
  switch (role) {
    case "superAdmin":
    case "admin":
      return MENU_SUPER_ADMIN;
    case "vendor":
      return MENU_VENDOR;
    case "bde":
      return MENU_BDE;
    default:
      return [];
  }
};

// Current User is SuperAdmin
export const isSuperAdmin = () => {
  const isit = LS_SERVICE.get("user_type") === "superAdmin";
  return isit ? isit : false;
};

// Current User is BDE
export const isBDE = () => {
  const isit = LS_SERVICE.get("user_type") === "bde";
  return isit ? isit : false;
};
// Current User is Vendor
export const isVendor = () => {
  const isit = LS_SERVICE.get("user_type") === "vendor";
  return isit ? isit : false;
};

// Current User is Admin
export const isAdmin = () => {
  const isit = LS_SERVICE.get("user_type") === "admin";
  return isit ? isit : false;
};

// Current User Login Id
export const getLoginId = () => {
  return LS_SERVICE.get("id");
};

// Current User Login Id
export const getVendorId = () => {
  return LS_SERVICE.get("vendor_id");
};

export const getSetting = () => {
  return new Promise((resolve) => {
    getAPI(
      SETTING,
      (data) => {
        console.log("getSetting:", data);

        if (data?.status) {
          resolve({
            logo: data?.data?.company_logo?.filePath || null,
            favicon: data?.data?.company_favicon?.filePath || null,
            ...data?.data,
          });
        } else {
          resolve(null);
        }
      },
      () => {
        resolve(null);
      },
    );
  });
};

export const SYS_CONFIG = await getSetting();

// Function to get the label for a user_type value
export const getHotelType = (value) => {
  // Find the matching user type in the USER_TYPE array
  const typeObj = HOTEL_TYPE.find((type) => type.value === value);

  // If a match is found, return the label, otherwise return a default value
  return typeObj ? typeObj.label : "Unknown Type";
};

// Function to get the label for a user_type value
export const getUserTypeLabel = (userType) => {
  // Find the matching user type in the USER_TYPE array
  const userTypeObj = USER_TYPE.find((type) => type.value === userType);

  // If a match is found, return the label, otherwise return a default value
  return userTypeObj ? userTypeObj.label : "Unknown User Type";
};

// Function to get the label for a page value
export const getPageTypeLabel = (pageType) => {
  // Find the matching user type in the PAGES_TYPE array
  const pageTypeObj = PAGES_TYPE.find((type) => type.value === pageType);

  // If a match is found, return the label, otherwise return a default value
  return pageTypeObj ? pageTypeObj.label : "Unknown Page Type";
};

export const getDyPageTypeLabel = (pageType) => {
  const pageTypeObj = DYNAMIC_PAGE_TYPE.find((type) => type.value === pageType);
  return pageTypeObj ? pageTypeObj.label : "Unknown Page Type";
};

// Function to get the label for a service value
export const getServiceLabel = (value) => {
  // Find the matching user type in the OTA_SERVICE_TYPE array
  const serviceObj = OTA_SERVICE_TYPE.find((type) => type.value === value);

  // If a match is found, return the label, otherwise return a default value
  return serviceObj ? serviceObj.label : "Unknown Service Type";
};

// Function to get the label for a service value
export const getRoomTypeLabel = (value) => {
  const obj = ROOM_CAPACITY_TYPES.find((type) => type.value === value);
  return obj ? obj.label : "Unknown Type";
};

export const getRoomCapicityLabel = (value) => {
  const obj = ROOM_CAPACITY_TYPES.find((type) => type.value === value);
  return obj ? obj.capacity : 0;
};

export const bookingStatusColors = {
  0: "#FFD700", // Pending - Yellow
  1: "#006400", // On Going - Green
  2: "#90EE90", // Completed - Light Green
  3: "#FF7F7F", // Cancelled - Light Red
  4: "#FFA500", // Accepted - Orange
};

export const bookingStatusText = {
  0: "Pending", // Pending - Yellow
  1: "On Going", // On Going - Green
  2: "Completed", // Completed - Light Green
  3: "Cancelled", // Cancelled - Light Red
  4: "Accepted", // Accepted - Orange
};

export const getGstRateAndAmount = (roomPrice, totalDays = 1) => {
  let gstRate = 0;

  if (roomPrice < 1000) {
    gstRate = 12;
  } else if (roomPrice <= 7500) {
    gstRate = 12;
  } else {
    gstRate = 18;
  }

  const baseAmount = roomPrice * totalDays;
  const gstAmount = (baseAmount * gstRate) / 100;

  return {
    gstRate,
    gstAmount: Number(gstAmount.toFixed(2)),
  };
};
export const getGstRate = (roomPrice) => {
  if (roomPrice < 1000) {
    return 12;
  } else if (roomPrice <= 7500) {
    return 12;
  } else {
    return 18;
  }
};

export const calculateBillAmountWithGST = (
  roomPrice,
  totalDays,
  advanceAmount = 0,
) => {
  const gstRate = getGstRate(roomPrice);

  const baseAmount = roomPrice * totalDays;
  const gstAmount = (baseAmount * gstRate) / 100;
  const totalWithGst = baseAmount + gstAmount;
  const billAmount = totalWithGst - advanceAmount;

  return {
    roomPrice: Number(roomPrice.toFixed(2)),
    totalDays,
    gstRate,
    baseAmount: Number(baseAmount.toFixed(2)),
    gstAmount: Number(gstAmount.toFixed(2)),
    totalWithGst: Number(totalWithGst.toFixed(2)),
    advance: Number(advanceAmount.toFixed(2)),
    billAmount: Number(billAmount.toFixed(2)),
  };
};

export const calculateTotalBill = (
  selected_rooms_ids,
  all_rooms_info,
  totalDays,
  advanceAmount = 0,
) => {
  console.log(
    "calculateTotalBill: ",
    selected_rooms_ids,
    all_rooms_info,
    totalDays,
  );

  let rooms = selected_rooms_ids;
  rooms = rooms.filter((room) => Object.keys(room).length > 0);

  let totalBase = 0;
  let totalGst = 0;
  let totalWithGst = 0;
  let totalBillAmount = 0;

  const roomBills = rooms.map((room) => {
    const bill = calculateBillAmountWithGST(
      parseInt(room.room_price || room.room_amt),
      totalDays,
      0,
    );

    totalBase += bill.baseAmount;
    totalGst += bill.gstAmount;
    totalWithGst += bill.totalWithGst;

    return {
      room_id: room.id,
      room_no: room.room_no,
      ...bill,
    };
  });

  totalBillAmount = totalWithGst - advanceAmount;
  return {
    rooms: roomBills,
    summary: {
      totalBase: Number(totalBase.toFixed(2)),
      totalGst: Number(totalGst.toFixed(2)),
      totalWithGst: Number(totalWithGst.toFixed(2)),
      grandTotal: Number(totalBillAmount.toFixed(2)),
    },
  };
};
